export default "__VITE_ASSET__DSMQbqlu__"